<template>
  <div class="o-flex-cols__row">
    <div class="o-flex-cols__row--1col overflow-x-auto">
      <div class="c-data-box">
        <div class="c-data-content__data">
          <p v-html="message"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .start_now {
    text-decoration: underline;
    color: #00BBCE;
  }
</style>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
}
</script>
